import { FiLogOut } from 'react-icons/fi';
import styles from './Logout.module.css';
import { useDispatch } from 'react-redux';
import { logoutUser } from '../../redux/slices/authSlice';

const Logout = () => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutUser());
    setTimeout(() => {
      window.location.href = '/';
    }, 300); 
  };

  return (
    <button className={styles.logoutBtn} onClick={handleLogout} aria-label="Logout">
        <span className={styles.icon}>
            <FiLogOut />
        </span>
    </button>
  );
};

export default Logout;